class DisableMfa {
    constructor() {
        this.twoFaHandleForm();
        this.disableLoginAuthEvents();
    }

    disableLoginAuthEvents(){
        $('#requiredAuthenticationForLogin').change(function (e){

            let message = `<span class="text-center text-primary">Disabling two-factor authentication reduces the security of your account. Are you sure you want to continue?</span>`;
            let button  = `Disable`;
            let buttonStyle = 'danger';
            if(e.target.checked){
                message = `<span class="text-center text-primary">Enabling multi-factor authentication increase the security of your account. Are you sure you want to continue?</span>`;
                button  = `Enable`;
                buttonStyle = 'success';

            }
            Swal.fire({
                html: message,
                buttonsStyling: false,
                reverseButtons: true,
                icon: 'question',
                showCancelButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: button,
                cancelButtonText: "Cancel",
                customClass: {
                    confirmButton: "btn btn-"+buttonStyle+" mt-0",
                    cancelButton: 'btn btn-light-primary mt-0'
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        url: '?do=changeLoginRequiredStatus',
                        type: 'POST',
                        dataType: '',
                        data: {
                            newStatus: e.target.checked ? 1 : 0
                        }
                    }).done(function(data) {
                        if(e.target.checked){
                            Swal.fire({
                                html: "<span class='text-primary fw-bolder'>Multi-Factor authentication at account login has been enabled!</span>",
                                icon: "success",
                                buttonsStyling: false,
                                showCancelButton: false,
                                showConfirmButton: false,
                            });
                            $('#disabledMFALoginNotification').addClass('d-none');
                        }else{
                            Swal.fire({
                                html: "<span class='text-primary fw-bolder'>Multi-Factor authentication at account login has been disabled!</span>",
                                icon: "success",
                                buttonsStyling: false,
                                showCancelButton: false,
                                showConfirmButton: false,
                            });
                            $('#disabledMFALoginNotification').removeClass('d-none');
                        }
                    });
                }else{
                    $('#requiredAuthenticationForLogin').prop( "checked", !e.target.checked );
                }

            });
        });

    }
    twoFaHandleForm(){
        const fv            = new MfaInputValidator('frm-disableTwoStepForm-verifyMFAForm').enableMFAFormValidation();
        const form          = document.getElementById('frm-disableTwoStepForm-verifyMFAForm');
        const submitButton  = document.getElementById('disable-two-step-submit');
        const thisClass = this;
        this.twoFaHandle();
        if(form){

            form.addEventListener('keyup', function(event) {
                if (event.code === 'Enter' || event.keyCode === 13)
                {
                    event.preventDefault();
                    submitButton.setAttribute('data-kt-indicator', 'on');
                    submitButton.disabled = true;
                    $('#frm-disableTwoStepForm-verifyMFAForm').submit();
                }
            });
            submitButton.addEventListener('click', function (e) {
                e.preventDefault();
                fv.validate().then(function(status) {
                    if(status === 'Valid'){
                        submitButton.setAttribute('data-kt-indicator', 'on');
                        submitButton.disabled = true;
                        $('#frm-disableTwoStepForm-verifyMFAForm').submit();
                    }else {
                        return;
                    }
                });
            });
            $.nette.ext('disableTwoStepFormExt', {
                success: function (payload, status, jqXHR, settings) {
                    let formID = settings.nette.form[0].attributes.id.value;
                    if(formID === 'frm-disableTwoStepForm-verifyMFAForm'){
                        submitButton.setAttribute('data-kt-indicator', 'off');
                        submitButton.disabled = false;
                        if(payload['status'] === 'Valid'){
                            bootstrap.Modal.getInstance(document.getElementById('kt_modal_two_factor_authentication_disable'), {}).hide();
                            Swal.fire({
                                html: "<span class='text-primary fw-bolder'>Multi-Factor authentication has been disabled !</span>",
                                icon: "success",
                                buttonsStyling: false,
                                showCancelButton: false,
                                showConfirmButton: false,
                            });
                        }
                    }
                }
            });
        }
    }
    twoFaHandle(){
        const form = document.querySelector('#frm-disableTwoStepForm-verifyMFAForm');
        if(form){
            new MfaInputEvents(form);
        }
    }
}
window.DisableMFA = DisableMfa;